export enum UserQueryKeys {
  Profile = 'users/profile',
  UserBonus = 'users/bonus',
  ReferralVoucher = 'users/referral-voucher',
  Identity = 'users/identity',
}
